// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  padding: 0;
  font-family: "Calibri", "Roboto", sans-serif;
  font-size: 14px;
  margin: 0;
}

a {
  color: #00b7ff;
}

.link-green {
  color: #52823f;
  text-decoration: none;
}

.link-green:hover {
  color: #52823f;
  text-decoration: underline;
}

.navbar .nav-link.active {
  color: #fff !important;
  background-color: transparent;
  box-shadow: inset 0 -2px 0 #fff;
  border-radius: 0;
}

.navbar .nav-link:hover {
  color: #fff;
}

#chat1 .form-outline .form-control ~ .form-notch div {
  pointer-events: none;
  border: 1px solid;
  border-color: #eee;
  box-sizing: border-box;
  background: transparent;
}

#chat1 .form-outline .form-control ~ .form-notch .form-notch-leading {
  left: 0;
  top: 0;
  height: 100%;
  border-right: none;
  border-radius: 0.65rem 0 0 0.65rem;
}

#chat1 .form-outline .form-control ~ .form-notch .form-notch-middle {
  flex: 0 0 auto;
  max-width: calc(100% - 1rem);
  height: 100%;
  border-right: none;
  border-left: none;
}

#chat1 .form-outline .form-control ~ .form-notch .form-notch-trailing {
  flex-grow: 1;
  height: 100%;
  border-left: none;
  border-radius: 0 0.65rem 0.65rem 0;
}

#chat1 .form-outline .form-control:focus ~ .form-notch .form-notch-leading {
  border-top: 0.125rem solid #b9d2b0;
  border-bottom: 0.125rem solid #b9d2b0;
  border-left: 0.125rem solid #b9d2b0;
}

#chat1 .form-outline .form-control:focus ~ .form-notch .form-notch-leading,
#chat1 .form-outline .form-control.active ~ .form-notch .form-notch-leading {
  border-right: none;
  transition: all 0.2s linear;
}

#chat1 .form-outline .form-control:focus ~ .form-notch .form-notch-middle {
  border-bottom: 0.125rem solid;
  border-color: #b9d2b0;
}

#chat1 .form-outline .form-control:focus ~ .form-notch .form-notch-middle,
#chat1 .form-outline .form-control.active ~ .form-notch .form-notch-middle {
  border-top: none;
  border-right: none;
  border-left: none;
  transition: all 0.2s linear;
}

#chat1 .form-outline .form-control:focus ~ .form-notch .form-notch-trailing {
  border-top: 0.125rem solid #b9d2b0;
  border-bottom: 0.125rem solid #b9d2b0;
  border-right: 0.125rem solid #b9d2b0;
}

#chat1 .form-outline .form-control:focus ~ .form-notch .form-notch-trailing,
#chat1 .form-outline .form-control.active ~ .form-notch .form-notch-trailing {
  border-left: none;
  transition: all 0.2s linear;
}

#chat1 .form-outline .form-control:focus ~ .form-label {
  color: #39c0ed;
}

#chat1 .form-outline .form-control ~ .form-label {
  color: #bfbfbf;
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,4CAA4C;EAC5C,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,MAAM;EACN,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;;EAEE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;;EAEE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["body {\n  padding: 0;\n  font-family: \"Calibri\", \"Roboto\", sans-serif;\n  font-size: 14px;\n  margin: 0;\n}\n\na {\n  color: #00b7ff;\n}\n\n.link-green {\n  color: #52823f;\n  text-decoration: none;\n}\n\n.link-green:hover {\n  color: #52823f;\n  text-decoration: underline;\n}\n\n.navbar .nav-link.active {\n  color: #fff !important;\n  background-color: transparent;\n  box-shadow: inset 0 -2px 0 #fff;\n  border-radius: 0;\n}\n\n.navbar .nav-link:hover {\n  color: #fff;\n}\n\n#chat1 .form-outline .form-control ~ .form-notch div {\n  pointer-events: none;\n  border: 1px solid;\n  border-color: #eee;\n  box-sizing: border-box;\n  background: transparent;\n}\n\n#chat1 .form-outline .form-control ~ .form-notch .form-notch-leading {\n  left: 0;\n  top: 0;\n  height: 100%;\n  border-right: none;\n  border-radius: 0.65rem 0 0 0.65rem;\n}\n\n#chat1 .form-outline .form-control ~ .form-notch .form-notch-middle {\n  flex: 0 0 auto;\n  max-width: calc(100% - 1rem);\n  height: 100%;\n  border-right: none;\n  border-left: none;\n}\n\n#chat1 .form-outline .form-control ~ .form-notch .form-notch-trailing {\n  flex-grow: 1;\n  height: 100%;\n  border-left: none;\n  border-radius: 0 0.65rem 0.65rem 0;\n}\n\n#chat1 .form-outline .form-control:focus ~ .form-notch .form-notch-leading {\n  border-top: 0.125rem solid #b9d2b0;\n  border-bottom: 0.125rem solid #b9d2b0;\n  border-left: 0.125rem solid #b9d2b0;\n}\n\n#chat1 .form-outline .form-control:focus ~ .form-notch .form-notch-leading,\n#chat1 .form-outline .form-control.active ~ .form-notch .form-notch-leading {\n  border-right: none;\n  transition: all 0.2s linear;\n}\n\n#chat1 .form-outline .form-control:focus ~ .form-notch .form-notch-middle {\n  border-bottom: 0.125rem solid;\n  border-color: #b9d2b0;\n}\n\n#chat1 .form-outline .form-control:focus ~ .form-notch .form-notch-middle,\n#chat1 .form-outline .form-control.active ~ .form-notch .form-notch-middle {\n  border-top: none;\n  border-right: none;\n  border-left: none;\n  transition: all 0.2s linear;\n}\n\n#chat1 .form-outline .form-control:focus ~ .form-notch .form-notch-trailing {\n  border-top: 0.125rem solid #b9d2b0;\n  border-bottom: 0.125rem solid #b9d2b0;\n  border-right: 0.125rem solid #b9d2b0;\n}\n\n#chat1 .form-outline .form-control:focus ~ .form-notch .form-notch-trailing,\n#chat1 .form-outline .form-control.active ~ .form-notch .form-notch-trailing {\n  border-left: none;\n  transition: all 0.2s linear;\n}\n\n#chat1 .form-outline .form-control:focus ~ .form-label {\n  color: #39c0ed;\n}\n\n#chat1 .form-outline .form-control ~ .form-label {\n  color: #bfbfbf;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
